import ReviewedCounter1 from './svg/icon-reviewed-counter-1.svg?component'
import ReviewedCounter2 from './svg/icon-reviewed-counter-2.svg?component'
import ReviewedCounter3 from './svg/icon-reviewed-counter-3.svg?component'
import ReviewedCounter4Plus from './svg/icon-reviewed-counter-4+.svg?component'
import ReviewedNotByYouCounter1 from './svg/icon-reviewed-not-by-you-counter-1.svg?component'
import ReviewedNotByYouCounter2 from './svg/icon-reviewed-not-by-you-counter-2.svg?component'
import ReviewedNotByYouCounter3 from './svg/icon-reviewed-not-by-you-counter-3.svg?component'
import ReviewedNotByYouCounter4Plus from './svg/icon-reviewed-not-by-you-counter-4+.svg?component'

import type { DefineComponent } from 'vue'
import reviewedCounter1Inline from './svg/icon-reviewed-counter-1.svg?inline'
import reviewedCounter2Inline from './svg/icon-reviewed-counter-2.svg?inline'
import reviewedCounter3Inline from './svg/icon-reviewed-counter-3.svg?inline'
import reviewedCounter4PlusInline from './svg/icon-reviewed-counter-4+.svg?inline'
import reviewedNotByYouCounter1Inline from './svg/icon-reviewed-not-by-you-counter-1.svg?inline'
import reviewedNotByYouCounter2Inline from './svg/icon-reviewed-not-by-you-counter-2.svg?inline'
import reviewedNotByYouCounter3Inline from './svg/icon-reviewed-not-by-you-counter-3.svg?inline'
import reviewedNotByYouCounter4PlusInline from './svg/icon-reviewed-not-by-you-counter-4+.svg?inline'

const reviewedIcons = [
  ReviewedCounter1,
  ReviewedCounter2,
  ReviewedCounter3,
] as DefineComponent[]

const notByYouIcons = [
  ReviewedNotByYouCounter1,
  ReviewedNotByYouCounter2,
  ReviewedNotByYouCounter3,
] as DefineComponent[]

const reviewedInlineIcons: string[] = [
  reviewedCounter1Inline,
  reviewedCounter2Inline,
  reviewedCounter3Inline,
]

const notByYouInlineIcons: string[] = [
  reviewedNotByYouCounter1Inline,
  reviewedNotByYouCounter2Inline,
  reviewedNotByYouCounter3Inline,
]

export function getReviewCounterIcon(
  reviewedByCurrentUser: boolean,
  count: number
): DefineComponent {
  if (count <= 0) {
    return reviewedByCurrentUser ? reviewedIcons[0] : notByYouIcons[0]
  }

  if (count >= 4) {
    return (
      reviewedByCurrentUser
        ? ReviewedCounter4Plus
        : ReviewedNotByYouCounter4Plus
    ) as DefineComponent
  }

  const icons = reviewedByCurrentUser ? reviewedIcons : notByYouIcons
  return icons[count - 1]
}

export function getReviewCounterIconInline(
  reviewedByCurrentUser: boolean,
  count: number
): string {
  if (count <= 0) {
    return reviewedByCurrentUser
      ? reviewedInlineIcons[0]
      : notByYouInlineIcons[0]
  }

  if (count >= 4) {
    return reviewedByCurrentUser
      ? reviewedCounter4PlusInline
      : reviewedNotByYouCounter4PlusInline
  }

  const icons = reviewedByCurrentUser
    ? reviewedInlineIcons
    : notByYouInlineIcons
  return icons[count - 1]
}
